export default {
    CAPTCHA_ERROR: "Captcha error. Please, try it again.",
    EMAIL_DO_NOT_MATCH: "Entered emails do not match",
    PASSWORD_TOO_SHORT: "Entered password is too short. Expected more than 6 characters",
    INTERNAL_SERVER_ERROR: "Internal Server Error. Please contact support if problems persist.",
    WRONG_PASSWORD_OR_ACCOUNT_DOES_NOT_EXISTS: "Wrong password or username does not exists",
    INVALID_ACTIVATION_CODE: "Invalid activation code",
};